import React from "react";

const Pedidos = () => {
  const orders = [
    {
      id: "HV-INV-00425",
      date: "2024-12-17",
      items: "Plugins",
      total: "$30.00",
      status: "Pagado",
    },
    {
      id: "HV-INV-00426",
      date: "2024-12-18",
      items: "Suscripción",
      total: "$50.00",
      status: "No pagado",
    },
    {
      id: "HV-INV-00427",
      date: "2024-12-19",
      items: "Hosting",
      total: "$100.00",
      status: "Acreditado",
    },
  ];

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Facturas</h2>
      <div className="bg-gray-100 p-4 rounded-lg shadow">
        <div className="flex justify-between items-center mb-4">
          <div className="flex space-x-4">
            <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
              Todos
            </button>
            <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">
              Pagado
            </button>
            <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">
              No pagado
            </button>
            <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">
              Acreditado
            </button>
          </div>
          <input
            type="text"
            placeholder="Búsqueda rápida por número de factura..."
            className="px-4 py-2 border border-gray-300 rounded-lg w-1/3"
          />
        </div>

        <div className="space-y-4">
          {orders.map((order) => (
            <div
              key={order.id}
              className="p-4 bg-white rounded-lg shadow flex justify-between items-center"
            >
              <div>
                <p className="text-lg font-bold">{order.id}</p>
                <p className="text-sm text-gray-500">Item(s): {order.items}</p>
                <p className="text-sm text-gray-500">Emitida: {order.date}</p>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold">{order.total}</p>
                <p
                  className={
                    order.status === "Pagado"
                      ? "text-green-500 font-bold"
                      : order.status === "No pagado"
                      ? "text-red-500 font-bold"
                      : "text-blue-500 font-bold"
                  }
                >
                  {order.status.toUpperCase()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pedidos;